<template>
  <div @click="handleClose" class="back">
    <q-btn flat round icon="close" /> Назад
  </div>
  <div class="wrapper">
    <div class="performers-block block">
      <div class="project-header">
        <BlockItem title="Название проекта">{{
          basicData.project_name
        }}</BlockItem>
        <BlockItem title="ЖК">{{ basicData.resident_name }}</BlockItem>
      </div>

      <div class="performers-table">
        <CustomTable
          title="Исполнители проекта"
          :rowsData="this.projectPerformersData"
          :columns="this.performersColumns"
          :loading="isEntrancesFetching"
          :small="true"
          :custom-body="true"
          :sticky-header="true"
          :add-btn="true"
          :on-add-click="this.handleAddClick"
        >
          <template #customBody="props">
            <q-tr>
              <custom-table-cell align="left">
                {{ props.row.employee_fio }}
              </custom-table-cell>
              <custom-table-cell align="left">
                {{ props.row.assign_type_name }}
              </custom-table-cell>
              <custom-table-cell align="left">
                {{ props.row.contractor_name }}
              </custom-table-cell>

              <custom-table-cell align="center" vertical-align="center">
                <CustomIcon
                  icon="edit"
                  green
                  title="Редактировать"
                  @click="handleEditPerformerClick(props.row)"
                />
              </custom-table-cell>

              <custom-table-cell align="center" vertical-align="center">
                <CustomIcon
                  icon="trash"
                  delete
                  :approve-mode="true"
                  :loading="this.loading"
                  :approve="() => this.onDeleteSubmit(props.row.project_assign_id)"
                />
              </custom-table-cell>
            </q-tr>
          </template>
        </CustomTable>
      </div>
    </div>

    <div class="entrances-block block">
      <CustomTable
        title="Подъезды"
        :rowsData="this.entrancesData"
        :columns="this.entrancesColumns"
        :loading="isEntrancesFetching"
        :small="true"
        :custom-body="true"
        :sticky-header="true"
      >
        <template #top-right>
          <div class="header-actions">
            <q-btn
              v-if="hasAnyChanges()"
              label="Сохранить"
              color="primary"
              @click="this.handleSaveClick"
              class="action-btn"
              icon="save"
              size="sm"
            />
            <q-btn
              v-if="hasAnyChanges()"
              label="Отменить изменения"
              color="orange"
              @click="this.resetChanges"
              class="action-btn ml-2"
              icon="loop"
              size="sm"
            />
          </div>
        </template>
        <template #customBody="props">
          <q-tr>
            <custom-table-cell align="center" vertical-align="center">
              {{ props.row.project_entrance_id }}
            </custom-table-cell>
            <custom-table-cell align="center" vertical-align="center">
              {{ props.row.entrance }}
            </custom-table-cell>
            <custom-table-cell align="center" vertical-align="center">
              <CustomInput
                :autoMinWidth="true"
                :showClearIcon="false"
                :value="
                  tempEntrancesData[props.row.project_entrance_id] ||
                  props.row.block_name
                "
                :style="`background-color: ${
                  hasAnyChanges(props.row.project_entrance_id)
                    ? '#d0ffc3'
                    : 'unset'
                }; margin-bottom: 10px;`"
                @change_input="
                  (value) =>
                    handleInputChange(props.row.project_entrance_id, value)
                "
              />
            </custom-table-cell>
          </q-tr>
        </template>
      </CustomTable>
    </div>
  </div>
</template>

<script>
import BlockItem from "@/components/common/BlockItem";
import CustomIcon from "@/components/common/CustomIcon";
import CustomInput from "@/components/form/CustomInput";
import CustomTable from "@/components/common/CustomTable";
import CustomTableCell from "@/components/common/CustomTable/custom-table-cell";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import {
  entrancesColumns,
  performersColumns,
  getEntrancesBlockInfo,
  updEntrancesBlockInfo,
  getEmployeeList,
  updateShellProjectPerfomancer,
  getPerformersByProjectId,
  deleteShellProjectPerfomancer,
} from "@/views/ShellProjects/services";

// ДЛЯ модалки
import { MODAL_NAMES } from "@/constants";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import ChangePaymentStatus from "@/components/modal/modals/ChangePaymentStatus.vue";

export default {
  name: "ShellProjects",

  props: {
    projectData: Object,
    basicData: Object,
  },

  components: {
    BlockItem,
    CustomIcon,
    CustomInput,
    CustomTable,
    CustomTableCell,
  },

  async mounted() {
    await this.getPerformersByProjectId();
    await this.getEntrancesInfo();
    // console.log("this.formData", this.formData)
    // console.log("this.projData", this.projData)
  },

  data() {
    return {
      // # 1 Пропсы из родителя
      projData: this.projectData,
      basicData: this.basicData,

      // # 2 Блок исполнителей
      projectData: {
        project_id: this.projectData.project_id || "",
      },
      isPerformersFetching: false,
      performersColumns,
      projectPerformersData: [],
      assign_types: [],

      // # 3 Блок подъездов
      isEntrancesFetching: false,
      entrancesColumns,
      entrancesData: [],
      tempEntrancesData: {},

      // 4 Общие переменные
      saveLoading: false,
      infoLoading: false,

      employeesList: [],
    };
  },

  methods: {
    // # 1 Блок исполнителей
    async getPerformersByProjectId() {
      this.isPerformersFetching = true;
      try {
        const res = await getPerformersByProjectId(this.projectData.project_id);
        this.projectPerformersData = res;
      } catch (error) {
      } finally {
        this.isPerformersFetching = false;
      }
    },

    async getAssignTypes() {
      try {
        const res = await getPerformersByProjectId(this.projectData.project_id);
        this.assign_types = res;
      } catch (error) {}
    },

    async handleAddClick() {
      this.$store.commit(
        appActions.showModal(MODAL_NAMES.UPD_SHL_PROJECT_PERFOMANCER, {
          onSubmit: (body) => this.onUpdatePerformerSubmit(body),
          title: "Создать исполнителя",
          body: { project_id: this.projectData.project_id },
        })
      );
    },

    async onDeleteSubmit(project_assign_id) {
      const body = { project_assign_id };
      try {
        this.isPerformersFetching = true;
        const res = await deleteShellProjectPerfomancer(body);
        this.projectPerformersData = res;
      } catch (error) {
      } finally {
        this.isPerformersFetching = false;
      }
    },

    // # 2 Блок подъездов
    async getEntrancesInfo() {
      this.isEntrancesFetching = true;
      try {
        const res = await getEntrancesBlockInfo(this.projectData.project_id);
        if (res) {
          this.entrancesData = res;
        }
      } catch (error) {
        console.error("Ошибка загрузки информации о подъездах:", error);
      } finally {
        this.isEntrancesFetching = false;
      }
    },

    handleInputChange(id, value) {
      this.tempEntrancesData = {
        ...this.tempEntrancesData,
        [id]: value,
      };
    },

    resetChanges() {
      this.tempEntrancesData = {};
    },

    hasAnyChanges(project_entrance_id) {
      if (project_entrance_id === undefined || project_entrance_id === null) {
        return Object.keys(this.tempEntrancesData).length > 0;
      }

      const row = this.entrancesData.find(
        (r) => r.project_entrance_id === project_entrance_id
      );
      if (!row) return false;

      const originalBlock = row.block_name;
      return (
        this.tempEntrancesData[project_entrance_id] !== undefined &&
        this.tempEntrancesData[project_entrance_id] !== originalBlock
      );
    },

    // # 3 Методы сохранения ищменений
    async handleSaveClick() {
      if (!this.hasAnyChanges()) {
        this.showSucceedSnackbar("Нет изменений для сохранения");
        return;
      }

      const blocks = this.entrancesData.map((row) => {
        const id = row.project_entrance_id;
        return {
          project_entrance_id: id,
          block_name:
            this.tempEntrancesData[id] !== undefined
              ? this.tempEntrancesData[id]
              : row.block_name,
        };
      });

      const payload = {
        project_id: this.projectData.project_id,
        blocks,
      };

      try {
        const res = await updEntrancesBlockInfo(payload);
        this.tempEntrancesData = {};
        if (res) {
          this.entrancesData = res;
          this.showSucceedSnackbar("Изменения успешно сохранены");
        }
      } catch (error) {
        console.error("Ошибка сохранения изменений подъездов:", error);
      }
    },

    handleEditPerformerClick(row) {
      this.$store.commit(
        appActions.showModal(MODAL_NAMES.UPD_SHL_PROJECT_PERFOMANCER, {
          onSubmit: (body) => this.onUpdatePerformerSubmit(body),
          title: "Изменить исполнителя",
          body: { ...row, project_id: this.projectData.project_id },
        })
      );
    },
    async onUpdatePerformerSubmit(body) {
      try {
        const res = await updateShellProjectPerfomancer(body);
        if (!res) return;

        // Перезагружаем данные исполнителей
        await this.getPerformersByProjectId();

        this.showSucceedSnackbar();
        this.$store.commit(appActions.closeModal());
      } catch (error) {
        console.error("Ошибка обновления исполнителя:", error);
        this.showErrorSnackbar("Ошибка при обновлении исполнителя");
      }
    },

    //  # 4 Общие методы
    async getEmployeesList() {
      try {
        const res = await getEmployeeList();
        if (res) {
          this.employeesList = res;
        }
      } catch (error) {
        console.error("Ошибка загрузки общего списка сотрудников:", error);
      }
    },

    handleClose() {
      this.$emit("close");
    },
  },
  setup() {
    const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar();
    return { showSucceedSnackbar, showErrorSnackbar };
  },
};
</script>

<style scoped lang="scss">
// #1 Общие стили
.back {
  border-radius: 20px;
  cursor: pointer;
  width: 110px;
  margin-bottom: 20px;
}
.back:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.wrapper {
  display: flex;
  gap: 25px;
  align-items: flex-start; /* «прижать» все блоки к верху */
}
@media (max-width: 1299px) {
  .wrapper {
    flex-wrap: wrap;
  }
}
.block {
  padding: 20px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  width: max-content;
}

// #2 Блок исполнителей
.performers-block {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
.project-header {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
}

// #3 Блок подъездов
.entrances-block {
  width: 450px;
}
</style>
